/* eslint-disable class-methods-use-this */
import qs from 'qs';

import DomainManager from '../../utils/DomainManager';

const key = 'union-recent-search';

function isValidRecentKeywords(savedRecents: unknown): savedRecents is Array<string> {
  if (Array.isArray(savedRecents)) {
    return savedRecents.every((keyword) => typeof keyword === 'string');
  }

  return false;
}

class SearchManager {
  static recents =
    typeof window !== 'undefined' &&
    typeof localStorage !== 'undefined' &&
    localStorage.getItem(key)
      ? (() => {
          try {
            const stored = localStorage.getItem(key);
            const savedRecents = stored ? JSON.parse(stored) : [];

            return isValidRecentKeywords(savedRecents) ? savedRecents : [];
          } catch (err) {
            return [];
          }
        })()
      : [];

  syncRecentKeywords(keywords: Array<string> | null = null) {
    SearchManager.recents = keywords ? [...keywords] : [];
  }

  getRecentKeywords() {
    return SearchManager.recents;
  }

  setRecentKeywords(keyword: string) {
    const currentKeywords = Array.isArray(SearchManager.recents) ? [...SearchManager.recents] : [];

    const filteredKeywords = currentKeywords
      .filter((currentKeyword) => currentKeyword !== keyword)
      .slice(0, 9);
    const newRecentKeywords = [keyword, ...filteredKeywords];

    localStorage.setItem(key, JSON.stringify(newRecentKeywords));

    this.syncRecentKeywords(newRecentKeywords);
  }

  hasRecentKeywords() {
    return SearchManager.recents && SearchManager.recents.length > 0;
  }

  removeRecentKeyword(keyword: string) {
    const currentKeywords = Array.isArray(SearchManager.recents) ? [...SearchManager.recents] : [];
    const newKeywords = currentKeywords.filter((k) => k !== keyword);
    localStorage.setItem(key, JSON.stringify(newKeywords));
    this.syncRecentKeywords(newKeywords);
  }

  removeRecentKeywords() {
    localStorage.removeItem(key);
    this.syncRecentKeywords();
  }

  getSearchQuery() {
    const { q } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    return q;
  }

  redirectSearchPage(query: string, targetEnv: string) {
    if (!query) {
      return;
    }

    const isEmptyKeyword = query.trim().length === 0;

    if (!isEmptyKeyword) {
      this.setRecentKeywords(query);
    }
    const encodeQuery = encodeURIComponent(query);
    const domainManager = new DomainManager(targetEnv);
    window.location.href = `${domainManager.getTravelerServiceDomain()}/search-bridge?q=${encodeQuery}`;
  }
}

export default SearchManager;
